import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { inputErros } from '../../errors';

@Component({
    selector: 'input-error',
    templateUrl: './input-error.component.html',
    styleUrls: ['./input-error.component.css'],
    standalone: false
})
export class InputErrorComponent implements OnChanges {
    @Input() id;
    @Input() control;
    @Input() message;
    isFormControl = false;

    constructor() {
        this.isFormControl = this.control != null;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.control?.currentValue) {
            this.isFormControl = true;
        }
    }

    showError() {
        if (this.isFormControl) {
            return this.control.errors && this.control.touched;
        }
        return this.message != null && this.message !== '';
    }

    getFirstError(errors) {
        return Object.keys(errors)[0];
    }

    translateError(error) {
        
        let idError = this.removeTrailingNumbers(this.id);
        if (
            inputErros.hasOwnProperty(idError) &&
            inputErros[idError].hasOwnProperty(error)
        ) {
            return inputErros[idError][error];
        }
        if (inputErros.hasOwnProperty(error)) {
            return inputErros[error];
        }
        return `no existe mensaje de error para ${idError} ${error}`;
    }

    private removeTrailingNumbers(str: string): string {
        return str?.replace(/\d+$/, '');
    }
}
